import React from 'react';
import TerminalShell from './terminal/TerminalShell';

const Layout = ({ children }) => <TerminalShell>{children}</TerminalShell>;

export default Layout;
